import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
// import DownloadFile from './../../../commons/DownloadFile.js';

export default class ReceivingFacilityMapping extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Receiving Facility Mapping
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/receiving/facility-mapping"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SellerReceiving/Components/ReceivingFacilityMapping.js